import { Card, CardContent } from "../ui/card";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Award, MessageCircle, User } from "lucide-react";

export const WhyChooseForm = ({ register, setValue, customers }) => (
  <>
    {/* Consultant & Company Info */}
    <Card className="border-2 border-green-400">
      <div className="bg-green-600 px-3 py-2">
        <h3 className="font-bold text-white flex items-center gap-2 text-sm">
          <User className="h-4 w-4" />
          Consultant & Company
        </h3>
      </div>
      <CardContent className="p-3 space-y-3">
        <div className="grid grid-cols-2 gap-2">
          <div>
            <Label className="text-xs">Consultant Name</Label>
            <Input {...register("why_consultant_name")} placeholder="Sunny" className="h-8 mt-1" />
          </div>
          <div>
            <Label className="text-xs">Title</Label>
            <Input {...register("why_consultant_title")} placeholder="Customer Consultant" className="h-8 mt-1" />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <div>
            <Label className="text-xs">Company Reg No.</Label>
            <Input {...register("why_company_reg")} placeholder="16811153" className="h-8 mt-1" />
          </div>
          <div>
            <Label className="text-xs">Insurance</Label>
            <Input {...register("why_insurance_amount")} placeholder="£50,000" className="h-8 mt-1" />
          </div>
        </div>
        <div>
          <Label className="text-xs">Companies House Link</Label>
          <Input {...register("why_companies_house_link")} placeholder="https://..." className="h-8 mt-1 text-xs" />
        </div>
        <div>
          <Label className="text-xs">Video/Photo Upload Link</Label>
          <Input {...register("why_video_upload_link")} placeholder="https://..." className="h-8 mt-1 text-xs" />
        </div>
      </CardContent>
    </Card>

    {/* Hero Section */}
    <Card className="border-2 border-purple-300">
      <div className="bg-purple-600 px-3 py-2">
        <h3 className="font-bold text-white flex items-center gap-2 text-sm">
          <Award className="h-4 w-4" />
          🏆 Hero Section
        </h3>
      </div>
      <CardContent className="p-3 space-y-3">
        <div>
          <Label className="text-xs">Headline</Label>
          <Input {...register("why_headline")} className="h-9 mt-1" />
        </div>
        <div>
          <Label className="text-xs">Introduction</Label>
          <Textarea {...register("why_intro")} className="min-h-[80px] text-sm mt-1" />
        </div>
      </CardContent>
    </Card>

    {/* Our Promises */}
    <Card className="border-2 border-yellow-300">
      <div className="bg-yellow-500 px-3 py-2">
        <h3 className="font-bold text-black flex items-center gap-2 text-sm">
          🤝 Our Promises
        </h3>
      </div>
      <CardContent className="p-3">
        <Textarea {...register("why_promises")} placeholder="One promise per line..." className="min-h-[100px] text-sm" />
        <p className="text-xs text-gray-500 mt-1">Each line = one bullet point</p>
      </CardContent>
    </Card>

    {/* Van Fleet Image Links */}
    <Card className="border-2 border-slate-400">
      <div className="bg-slate-700 px-3 py-2">
        <h3 className="font-bold text-white flex items-center gap-2 text-sm">
          🚛 Fleet Van Image Links
        </h3>
      </div>
      <CardContent className="p-3 space-y-2">
        <div>
          <Label className="text-xs">🚐 Luton Van (Students/Single Items)</Label>
          <Input {...register("why_luton_van_image")} placeholder="https://..." className="h-7 mt-1 text-xs" />
        </div>
        <div>
          <Label className="text-xs">🚚 Maxi Mover (1-3 Bed Homes)</Label>
          <Input {...register("why_maxi_mover_image")} placeholder="https://..." className="h-7 mt-1 text-xs" />
        </div>
        <div>
          <Label className="text-xs">🚛 7.5 Ton Lorry (Large/Office)</Label>
          <Input {...register("why_ton_lorry_image")} placeholder="https://..." className="h-7 mt-1 text-xs" />
        </div>
      </CardContent>
    </Card>

    {/* Service Packages */}
    <Card className="border-2 border-gray-400">
      <div className="bg-gray-700 px-3 py-2">
        <h3 className="font-bold text-white flex items-center gap-2 text-sm">
          📦 Basic / Economy Move
        </h3>
      </div>
      <CardContent className="p-3 space-y-2">
        <Input {...register("why_economy_title")} placeholder="Package Title" className="h-8 text-sm" />
        <Textarea {...register("why_economy_details")} placeholder="Package details..." className="min-h-[50px] text-sm" />
        <Input {...register("why_economy_ideal")} placeholder="Perfect for:..." className="h-8 text-xs" />
      </CardContent>
    </Card>

    <Card className="border-2 border-yellow-400">
      <div className="bg-[#D4AF37] px-3 py-2">
        <h3 className="font-bold text-black flex items-center gap-2 text-sm">
          🛋️ Comfort Move ⭐
        </h3>
      </div>
      <CardContent className="p-3 space-y-2">
        <Input {...register("why_comfort_title")} placeholder="Package Title" className="h-8 text-sm" />
        <Textarea {...register("why_comfort_details")} placeholder="Package details..." className="min-h-[50px] text-sm" />
        <Input {...register("why_comfort_ideal")} placeholder="Perfect for:..." className="h-8 text-xs" />
      </CardContent>
    </Card>

    <Card className="border-2 border-blue-400">
      <div className="bg-blue-600 px-3 py-2">
        <h3 className="font-bold text-white flex items-center gap-2 text-sm">
          🏠 Complete Comfort Move 🔥
        </h3>
      </div>
      <CardContent className="p-3 space-y-2">
        <Input {...register("why_complete_title")} placeholder="Package Title" className="h-8 text-sm" />
        <Textarea {...register("why_complete_details")} placeholder="Package details..." className="min-h-[50px] text-sm" />
        <Input {...register("why_complete_ideal")} placeholder="Perfect for:..." className="h-8 text-xs" />
      </CardContent>
    </Card>

    <Card className="border-2 border-[#D4AF37]" style={{background: 'linear-gradient(135deg, #1F2937 0%, #111827 100%)'}}>
      <div className="bg-[#D4AF37] px-3 py-2">
        <h3 className="font-bold text-black flex items-center gap-2 text-sm">
          ✨ Premium Move 👑
        </h3>
      </div>
      <CardContent className="p-3 space-y-2">
        <Input {...register("why_premium_title")} placeholder="Package Title" className="h-8 text-sm" />
        <Textarea {...register("why_premium_details")} placeholder="Package details..." className="min-h-[50px] text-sm" />
        <Input {...register("why_premium_ideal")} placeholder="Perfect for:..." className="h-8 text-xs" />
      </CardContent>
    </Card>

    {/* Reviews */}
    <Card className="border-2 border-amber-400">
      <div className="bg-amber-500 px-3 py-2">
        <h3 className="font-bold text-black flex items-center gap-2 text-sm">
          💬 Customer Reviews
        </h3>
      </div>
      <CardContent className="p-3 space-y-4">
        <div className="bg-amber-50 p-2 rounded border">
          <Label className="text-xs font-bold text-amber-700">Review 1</Label>
          <Textarea {...register("why_review_1")} className="min-h-[50px] text-sm mt-1" />
          <div className="grid grid-cols-3 gap-1 mt-1">
            <Input {...register("why_review_1_author")} placeholder="Name" className="h-7 text-xs" />
            <Input {...register("why_review_1_location")} placeholder="Location" className="h-7 text-xs" />
            <Input {...register("why_review_1_package")} placeholder="Package" className="h-7 text-xs" />
          </div>
        </div>
        <div className="bg-green-50 p-2 rounded border">
          <Label className="text-xs font-bold text-green-700">Review 2</Label>
          <Textarea {...register("why_review_2")} className="min-h-[50px] text-sm mt-1" />
          <div className="grid grid-cols-3 gap-1 mt-1">
            <Input {...register("why_review_2_author")} placeholder="Name" className="h-7 text-xs" />
            <Input {...register("why_review_2_location")} placeholder="Location" className="h-7 text-xs" />
            <Input {...register("why_review_2_package")} placeholder="Package" className="h-7 text-xs" />
          </div>
        </div>
        <div className="bg-blue-50 p-2 rounded border">
          <Label className="text-xs font-bold text-blue-700">Review 3</Label>
          <Textarea {...register("why_review_3")} className="min-h-[50px] text-sm mt-1" />
          <div className="grid grid-cols-3 gap-1 mt-1">
            <Input {...register("why_review_3_author")} placeholder="Name" className="h-7 text-xs" />
            <Input {...register("why_review_3_location")} placeholder="Location" className="h-7 text-xs" />
            <Input {...register("why_review_3_package")} placeholder="Package" className="h-7 text-xs" />
          </div>
        </div>
        <div className="bg-purple-50 p-2 rounded border">
          <Label className="text-xs font-bold text-purple-700">Review 4</Label>
          <Textarea {...register("why_review_4")} className="min-h-[50px] text-sm mt-1" />
          <div className="grid grid-cols-3 gap-1 mt-1">
            <Input {...register("why_review_4_author")} placeholder="Name" className="h-7 text-xs" />
            <Input {...register("why_review_4_location")} placeholder="Location" className="h-7 text-xs" />
            <Input {...register("why_review_4_package")} placeholder="Package" className="h-7 text-xs" />
          </div>
        </div>
      </CardContent>
    </Card>

    {/* CUSTOM MESSAGE TO CUSTOMER - Why Us Tab */}
    <Card className="border-2 border-purple-400 bg-purple-50" data-testid="custom-recommendation-whyus">
      <div className="bg-purple-600 px-3 py-2">
        <h3 className="font-bold text-white flex items-center gap-2 text-sm">
          <MessageCircle className="h-4 w-4" />
          Your Message to Customer
        </h3>
      </div>
      <CardContent className="p-3 space-y-3">
        <p className="text-xs text-purple-700">Write a personal message to the customer:</p>
        
        <Textarea 
          {...register("custom_recommendation_message")} 
          placeholder="Example: I wanted to personally reach out and share why HomeGo is the perfect choice for your move..."
          className="min-h-[100px] text-sm border-2 border-purple-300 focus:border-purple-500"
          style={{ fontSize: '15px' }}
        />
        
        <div>
          <Label className="text-xs font-semibold text-purple-700 mb-2 block">Quick Templates:</Label>
          <div className="flex flex-wrap gap-2">
            <button
              type="button"
              onClick={() => setValue("custom_recommendation_message", 
                `I wanted to personally reach out and share why HomeGo Removals is the perfect choice for your upcoming move. With over 1000+ successful moves, we've built a reputation for reliability, care, and professionalism. Our team treats every home like their own, and we guarantee a stress-free experience from start to finish.`
              )}
              className="px-3 py-1.5 bg-purple-100 hover:bg-purple-200 text-purple-700 text-xs rounded-full border border-purple-300"
            >
              🏆 Why Choose Us
            </button>
            <button
              type="button"
              onClick={() => setValue("custom_recommendation_message", 
                `We understand moving can be stressful, especially if you'd like to take it easy or have mobility concerns. For your peace of mind, we offer a full packing service where our professional team will carefully pack ALL your belongings - from fragile china to heavy books. You just relax and let us handle everything! This is perfect for elderly customers, busy professionals, or anyone who wants a completely stress-free move.`
              )}
              className="px-3 py-1.5 bg-purple-100 hover:bg-purple-200 text-purple-700 text-xs rounded-full border border-purple-300"
            >
              👴 Packing for Elderly/Relaxed Move
            </button>
            <button
              type="button"
              onClick={() => setValue("custom_recommendation_message", 
                `What sets us apart? Every move is handled by our own trained staff - no subcontractors. We're fully insured up to £50,000, and our vehicles are GPS-tracked for your peace of mind. Plus, our dedicated consultant Sunny will be available throughout your entire moving journey. We don't just move your belongings; we move your life with care.`
              )}
              className="px-3 py-1.5 bg-purple-100 hover:bg-purple-200 text-purple-700 text-xs rounded-full border border-purple-300"
            >
              ✨ What Makes Us Special
            </button>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <input 
            type="checkbox" 
            {...register("show_custom_message")}
            className="h-4 w-4 rounded border-gray-300"
          />
          <Label className="text-xs">Show this message in email</Label>
        </div>
      </CardContent>
    </Card>
  </>
);
